import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CustomLayoutComponent } from './custom-layout/custom-layout.component';
import { QuicklinkModule, QuicklinkStrategy } from 'ngx-quicklink';
import { JWTAuthGuard } from './auth/jwtauth.guard';
import { VexRoutes } from '../@vex/interfaces/vex-route.interface';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { LegalNoticeComponent } from './components/legal-notice/legal-notice.component';
import { PrivacyComponent } from './components/privacy/privacy.component';
import { SettingsComponent } from './components/settings/settings.component';
import { UviComponent } from './components/uvi/uvi.component';
import { DevelopmentComponent } from './components/development/development.component';
import { TenantUnitDetailLegacyComponent } from './components/tenant-unit-detail-legacy/tenant-unit-detail-legacy.component';
import { UserProfileComponent } from './components/user-profile/user-profile.component';
import { RealEstateLegacyComponent } from './components/real-estate-legacy/real-estate-legacy.component';
import { RealEstatesLegacyComponent } from './components/real-estates-legacy/real-estates-legacy.component';
import { MassPrintingComponent } from './components/mass-printing/mass-printing.component';
import { PermissionsComponent } from './components/permissions/permissions.component';
import { DocumentTransferComponent } from './components/document-transfer/document-transfer.component';
import { BillingComponent } from './components/billings/billing/billing.component';
import { SupportAraappComponent } from './components/support-araapp/support-araapp.component';
import { UserManagementComponent } from './components/user-management/user-management.component';

const routes: VexRoutes = [
	{
		path: '',
		component: CustomLayoutComponent,
		children: [
			{
				path: '',
				redirectTo: '/dashboard',
				pathMatch: 'full',
			},
			{
				path: 'dashboard',
				component: DashboardComponent,
				canActivate: [JWTAuthGuard],
				data: {
					expectedRole: 'admin',
				},
			},
			{
				path: 'realestates',
				canActivate: [JWTAuthGuard],
				component: RealEstatesLegacyComponent,
			},
			{ path: 'realestates/:realEstateId', component: RealEstateLegacyComponent, canActivate: [JWTAuthGuard] },
			{
				path: 'realestates/:realEstateId/tenantunits/:tenantUnitId',
				component: TenantUnitDetailLegacyComponent,
				canActivate: [JWTAuthGuard],
			},
			{ path: 'uvi', component: UviComponent, canActivate: [JWTAuthGuard] },
			{
				path: 'realestates/:realEstateId/tenantunits/:tenantUnitId/uvi',
				component: UviComponent,
				canActivate: [JWTAuthGuard],
			},
			{
				path: 'ci/realestates/:realEstateId/tenantunits/:tenantUnitId/uvi',
				component: UviComponent,
				canActivate: [JWTAuthGuard],
			},
			{
				path: 'smoke-detector-checks/realestates',
				component: RealEstatesLegacyComponent,
				canActivate: [JWTAuthGuard],
			},
			{
				path: 'smoke-detector-checks/realestates/:realEstateId',
				component: RealEstateLegacyComponent,
				canActivate: [JWTAuthGuard],
			},
			// {
			// 	path: 'smoke-detector-checks/realestates/:realEstateId/tenantunits/:tenantUnitId',
			// 	component: SmokeDetectorsComponent,
			// 	canActivate: [JWTAuthGuard],
			// },
			// {
			//     path: 'smoke-detector-checks/realestates/:realEstateId/tenantunits/:tenantUnitId/smokedetectors/:smokedetectorId',
			//     component: SmokeDetectorCheckComponent,
			//     canActivate: [JWTAuthGuard]
			// },
			{ path: 'permissions', component: PermissionsComponent, canActivate: [JWTAuthGuard] },
			{ path: 'mass-printing', component: MassPrintingComponent, canActivate: [JWTAuthGuard] },
			{ path: 'settings', component: SettingsComponent, canActivate: [JWTAuthGuard] },
			{ path: 'legal-notice', component: LegalNoticeComponent, canActivate: [JWTAuthGuard] },
			{ path: 'privacy', component: PrivacyComponent, canActivate: [JWTAuthGuard] },
			{ path: 'datenschutz', component: PrivacyComponent, canActivate: [JWTAuthGuard] },
			{ path: 'development', component: DevelopmentComponent, canActivate: [JWTAuthGuard] },
			{ path: 'userProfile', component: UserProfileComponent, canActivate: [JWTAuthGuard] },
			{
				path: 'document-transfer',
				component: DocumentTransferComponent,
				canActivate: [JWTAuthGuard],
				data: { uploadType: 'transfer' },
			},
			{
				path: 'document-transfer/archive',
				component: DocumentTransferComponent,
				canActivate: [JWTAuthGuard],
				data: { uploadType: 'archive' },
			},
			{
				path: 'billing-units',
				component: RealEstatesLegacyComponent,
				canActivate: [JWTAuthGuard],
				runGuardsAndResolvers: 'always',
			},
			{
				path: 'billing-units/:billingId',
				component: BillingComponent,
				canActivate: [JWTAuthGuard],
				runGuardsAndResolvers: 'always',
			},
			{
				path: 'ara-app',
				component: SupportAraappComponent,
				canActivate: [JWTAuthGuard],
			},
			{
				path: 'user-management',
				component: UserManagementComponent,
				canActivate: [JWTAuthGuard],
			},
		],
	},
	// Otherwise redirect to landing
	{ path: '**', component: CustomLayoutComponent },
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, {
			//preloadingStrategy: PreloadAllModules,
			preloadingStrategy: QuicklinkStrategy,
			scrollPositionRestoration: 'enabled',
			anchorScrolling: 'enabled',
			onSameUrlNavigation: 'reload',
		}),
	],
	exports: [RouterModule, QuicklinkModule],
})
export class AppRoutingModule {}
